(function () {

	ImgsContainer = function (opts) {
		return (this instanceof ImgsContainer)
			? this.init(opts)
			: new ImgsContainer(opts);
	};

	ImgsContainer.prototype.init = function (opts) {
		var self = this;

		opts = opts || {};
		self.loadedCallback = opts.loadedCallback;
		self.updatedCallback = opts.updatedCallback;
		
		self.statClass = { loading: 'loading', loaded: 'loaded' };
		if (typeof opts.statClass !== "undefined") {
			self.statClass.loading = typeof opts.statClass.loading !== "undefined" ? opts.statClass.loading : self.statClass.loading;
			self.statClass.loaded = typeof opts.statClass.loaded !== "undefined" ? opts.statClass.loaded : self.statClass.loaded;
		}

		self.wrapper = [];
		for (var w = 0, len = opts.containerObj.length; w < len; w++) {
			var imgs = opts.containerObj[w].querySelectorAll('img, video');
			self.wrapper[w] = {
				obj : opts.containerObj[w],
				imgs : imgs,
				loader : [],
				loadedCount : 0
			};
			if (self.wrapper[w].imgs.length > 0) {
				self.load(w);
			} else {
				self.loaded(w);
			}
		}
	};

	ImgsContainer.prototype.load = function (w) {
		var self = this,
			theWrap = self.wrapper[w],
			tagName = '';

		theWrap.obj.classList.add(self.statClass.loading);

		for (var i=0, len=theWrap.imgs.length; i<len; i++) {
			theWrap.loader[i] = new Image();
			theWrap.loader[i].onload = function(){
				self.loadCount(w);
			};
			theWrap.loader[i].onerror = function(){
				self.loadCount(w);
			};
			tagName = theWrap.imgs[i].tagName.toUpperCase();
			if (tagName === 'IMG') {
				theWrap.loader[i].setAttribute('src', theWrap.imgs[i].getAttribute('src'));
			} else if (tagName === 'VIDEO') {
				theWrap.loader[i].setAttribute('src', theWrap.imgs[i].getAttribute('poster'));
			}
		}

	};

	ImgsContainer.prototype.loadCount = function (w) {
		var self = this,
			theWrap = self.wrapper[w];

		theWrap.loadedCount += 1;

		if (theWrap.loadedCount >= theWrap.imgs.length) {
			self.loaded(w);
		} else {
			self.updated();
		}
	}

	ImgsContainer.prototype.updated = function () {
		var self = this;
		if (typeof self.updatedCallback === "function") {
			self.updatedCallback(self);
		}
	};

	ImgsContainer.prototype.loaded = function (w) {
		var self = this;
		self.wrapper[w].obj.classList.remove(self.statClass.loading)
		self.wrapper[w].obj.classList.add(self.statClass.loaded);

		if (typeof self.loadedCallback === "function") {
			self.loadedCallback(self, self.wrapper[w].obj);
		}
	};

}());
